import { createContext, useContext } from 'react';

/**
 * İçinde bulunulan sekme bölmesi (TabPanes sağlar).
 *
 * Pasif sekmeler mount kalıyor (gizli + inert); ama pencereler body'ye taşındığı için
 * gizli sekmenin açtığı pencere öndeki sekmenin üstüne çıkıyor ve onu kilitliyordu. Pencereler
 * bu bağlamla kendi sekmeleri görünürken açılır. Sekme dışında (OctoLab, node görünümü,
 * testler) bağlam yoktur: o zaman her şey görünür sayılır.
 */
export interface TabPaneInfo {
  tabId: string;
  visible: boolean;
}

export const TabPaneContext = createContext<TabPaneInfo | null>(null);

export const useTabPane = () => useContext(TabPaneContext);
